import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TRecordState } from './record.type';
import dayjs, { Dayjs } from 'dayjs';

const initialState: TRecordState = {
  searchCondition: {
    dateTo: dayjs().toISOString(),
    dateFrom: dayjs().subtract(30, 'days').toISOString(),
    page: 1,
    pageSize: 10,
    sort: '',
  },
  records: [],
  totalRecordsCount: 0,
};

export const RecordSlice = createSlice({
  name: 'record',
  initialState,
  reducers: {
    setRecordSearchCondition: (
      state,
      action: PayloadAction<{
        [title: string]: string | Dayjs | boolean | number | string[];
      }>,
    ) => {
      state.searchCondition = {
        ...state.searchCondition,
        ...action.payload,
      };
    },
  },
});

export const { setRecordSearchCondition } = RecordSlice.actions;

export default RecordSlice.reducer;
